import { useDesignMaxTheme } from "@/packages";
import { removeHtmlTags } from "@/utils";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useCleanText } from "@shared/client";
import { type MainInfoResponse } from "@shared/server";
import { FONT } from "@styles/common";
import { useInView } from "react-intersection-observer";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useLocation } from "react-router-dom";

export const Banner = ({ catchPraise }: MainInfoResponse) => {
    const { main, sub } = catchPraise;
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const [ref] = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });
    const { pathname } = useLocation();

    const isRoomAndSpeicalPage = pathname.includes("specials") || pathname.includes("rooms");

    const { isMobile, isLaptop } = MEDIAS();
    const { cleanText } = useCleanText(sub.secondLine);

    return (
        <CustomContainer ref={ref} position="relative" w="100%" maxW="100%" p="0" m="0">
            <Flex
                w="100%"
                maxW="1600px"
                flexDir="column"
                rowGap="16px"
                textShadow="1px 0 3px rgba(0, 0, 0, 0.4)"
                pointerEvents="none"
            >
                <Box
                    sx={{
                        "& h2": {
                            color: COLORS.white,
                        },
                    }}
                >
                    <Text
                        as="h2"
                        sx={
                            isMobile
                                ? { ...FONT(isRoomAndSpeicalPage ? "notoSerif" : "cormorant", 20, 700, 1.2) }
                                : {
                                      ...FONT(
                                          isRoomAndSpeicalPage ? "notoSerif" : "cormorant",
                                          isLaptop ? 32 : 48,
                                          700,
                                          1.2,
                                      ),
                                  }
                        }
                    >
                        {main.firstLine ? removeHtmlTags(main.firstLine, "<br>").cleanText : ""}
                    </Text>
                    <Text
                        as="h2"
                        sx={
                            isMobile
                                ? { ...FONT(isRoomAndSpeicalPage ? "notoSerif" : "cormorant", 20, 700, 1.2) }
                                : {
                                      ...FONT(
                                          isRoomAndSpeicalPage ? "notoSerif" : "cormorant",
                                          isLaptop ? 32 : 48,
                                          700,
                                          1.2,
                                      ),
                                  }
                        }
                    >
                        {main.secondLine ? removeHtmlTags(main.secondLine, "<br>").cleanText : ""}
                    </Text>
                </Box>
                <Box
                    position="relative"
                    sx={{
                        "& p": {
                            color: COLORS.white,
                        },
                    }}
                >
                    <Text mb="4px" sx={{ ...FONT("pretendard", isMobile ? 14 : 16, 300, 1.5) }}>
                        {sub.firstLine}
                    </Text>
                    <Text sx={{ ...FONT("pretendard", isMobile ? 14 : 16, 300, 1.5) }}>
                        <Flex flexDir="column" gap="4px">
                            {Array.isArray(cleanText) ? cleanText.map((text) => <p key={text}>{text}</p>) : cleanText}
                        </Flex>
                    </Text>
                </Box>
            </Flex>
        </CustomContainer>
    );
};

export const CustomContainer = styled(Center)``;
